import { render, staticRenderFns } from "./Gallery21.vue?vue&type=template&id=0ee95b8d&scoped=true&"
import script from "./Gallery21.vue?vue&type=script&lang=js&"
export * from "./Gallery21.vue?vue&type=script&lang=js&"
import style0 from "./Gallery21.vue?vue&type=style&index=0&id=0ee95b8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee95b8d",
  null
  
)

export default component.exports